import React from 'react'; 
import dataService from 'utils/dataservice'; 
import {USER_SIGNIN,GOTO_URL,SHOW_LOADER,STATUS} from 'utils/constants';
import {translate, checkemailphone, checkphone, maskedEmail} from 'utils/common';
import {companyNameValidator, empty} from 'utils/validators';
import FormField from 'components/common/formfield/formfield';
import FormMsg from './formmessage';
import FormValidator from 'components/common/formvalidator';
const WAIT_INTERVAL = 1500;
const ENTER_KEY = 13;
class Login extends React.Component{
    constructor(props) {
        super(props);
        this.passwordMatch = this.passwordMatch.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.checkPasswordCmp = this.checkPasswordCmp.bind(this); 
        this.checkUserExist = this.checkUserExist.bind(this);
        this.handleEmailKeyDown = this.handleEmailKeyDown.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);        
        this.login = this.login.bind(this);
        this.sendForgotPswdLink = this.sendForgotPswdLink.bind(this);
        // this.setAsSignUp = this.setAsSignUp.bind(this);
        this.setSignIn = this.setSignIn.bind(this); 
        this.fieldPrefix = this.props.fieldPrefix || '';
        this.aliasFields = {
            [this.fieldPrefix+'email']:'email',
            [this.fieldPrefix+'password']:'password',
            //[this.fieldPrefix+'cpassword']:'cpassword',
            [this.fieldPrefix+'fullName']:'fullName',
            [this.fieldPrefix+'phoneNo']:'phoneNo',
            [this.fieldPrefix+'companyName']:'companyName',
            [this.fieldPrefix+'emailphone']:'emailphone',
            [this.fieldPrefix+'username']:'username',
            [this.fieldPrefix+'phone']:'phone',
        }
        this.toggleFields = [this.fieldPrefix+'companyName',this.fieldPrefix+'fullName',this.fieldPrefix+'email',this.fieldPrefix+'phoneNo',,this.fieldPrefix+'emailphone'];
        // this.toggleSignInFields = [this.fieldPrefix+'emailphone'];
        this.toggleSignInFields = [this.fieldPrefix+'username'];
        this.getPasswordFields =[this.fieldPrefix+'password'];
        this.getEmailPasswordFields =[this.fieldPrefix+'password', this.fieldPrefix+'email'];

        //this.toggleForgotpasswordFields = [this.fieldPrefix+'email'];
        //this.toggleFields = [this.fieldPrefix+'companyName',this.fieldPrefix+'cpassword',this.fieldPrefix+'fullName',this.fieldPrefix+'phoneNo'];
        this.signIn = !!this.props.signIn;
        this.ct = 1;
        const validationRules = [
            {
                field: this.fieldPrefix+'companyName',
                aliasField:'companyName',
				method: empty,
				validWhen: false,
				message: 'regn.company_name_required'
            },
            {
                field: this.fieldPrefix+'companyName',
                aliasField:'companyName',
				method: 'isLength',
                validWhen: true,
                args:[{max:83}],
				message: translate('regn.company_name_error2').replace('{0}', 83) 
            },
            // {
            //     field: this.fieldPrefix+'companyName',
            //     aliasField:'companyName',
			// 	method: companyNameValidator,
            //     validWhen: true,
			// 	message: translate('regn.company_name_error2').replace('{0}', 100) 
            // },
            { 
              field: this.fieldPrefix+'email', 
              aliasField:'email',
              method: empty, 
              validWhen: false, 
              message: 'regn.email_required' 
            },
            { 
              field: this.fieldPrefix+'email',
              aliasField:'email',
              method: 'isEmail', 
              validWhen: true, 
              message: 'regn.valid_email'
            },
            { 
              field: this.fieldPrefix+'password', 
              aliasField:'password',
              method: empty, 
              validWhen: false, 
              message: 'regn.password_required'
            },
            { 
                field: this.fieldPrefix+'password', 
                aliasField:'password',
                method: 'isLength', 
                validWhen: true, 
                args:[{min:8}],
                message: 'regn.password_length'
            },
            { 
                field: this.fieldPrefix+'password', 
                aliasField:'password',
                method: 'isLength', 
                validWhen: true, 
                args:[{max:20}],
                message: 'regn.password_length_exceed'
            },
            { 
                field: this.fieldPrefix+'password',
                aliasField:'password', 
                method: this.checkPasswordCmp, 
                validWhen: true,
                message: 'regn.password_info'
            },
            { 
                field: this.fieldPrefix+'emailphone', 
                aliasField:'emailphone',
                method: empty, 
                validWhen: false, 
                message: 'regn.emailphone_required'
            },
            { 
                field: this.fieldPrefix+'username', 
                aliasField:'username',
                method: empty, 
                validWhen: false, 
                message: translate('required.error').replace('{0}', translate('signin.username'))
            },
            { 
                field: this.fieldPrefix+'emailphone', 
                aliasField:'emailphone',
                method: checkemailphone, 
                validWhen: true, 
                message: 'regn.invalid_emailphone'
            },
            
            // { 
            //   field: this.fieldPrefix+'cpassword',
            //   aliasField:'cpassword', 
            //   method: empty, 
            //   validWhen: false, 
            //   message: 'regn.confirm_password_required'
            // },
            // { 
            //   field: this.fieldPrefix+'cpassword', 
            //   aliasField:'cpassword',
            //   method: this.passwordMatch,   // notice that we are passing a custom function here
            //   validWhen: true, 
            //   message: 'regn.password_doesnot_match'
            // },
            { 
                field: this.fieldPrefix+'fullName', 
                aliasField:'fullName',
                method: empty, 
                validWhen: false, 
                message: 'regn.name_required'
            },
            {
				field: this.fieldPrefix+'fullName', 
                aliasField:'fullName',
				method: 'isLength',
                validWhen: true,
                args:[{max:32}],
				message: translate('regn.name_error2').replace('{0}', 32) 
            },
            { 
                field: this.fieldPrefix+'phoneNo', 
                aliasField:'phoneNo',
                method: empty, 
                validWhen: false, 
                message: 'regn.phone_required'
            },
            // {
			// 	field: this.fieldPrefix+'phoneNo', 
            //     aliasField:'phoneNo',
			// 	method: 'isMobilePhone',				
			// 	validWhen: true, 
            //     args:['any'],
			// 	message: 'regn.phone_invalid'
            // }
            {
				field: this.fieldPrefix+'phoneNo', 
                aliasField:'phoneNo',
				method: checkphone,				
				validWhen: true, 
				message: 'regn.phone_invalid'
            },
            // {
			// 	field: this.fieldPrefix+'phoneNo', 
            //     aliasField:'phoneNo',
			// 	method: 'isLength',				
			// 	validWhen: true, 
            //     args:[{min:5}],
			// 	message: 'regn.phone_invalid'
            // }
        ];
        this.validator = new FormValidator(validationRules);
        if(this.signIn){
            this.validator.enableDisableRules(this.toggleFields,true);
            //if(this.props.forgotPassword) this.validator.enableDisableRules(this.toggleForgotpasswordFields,false);
        }else this.validator.enableDisableRules(this.toggleSignInFields,true);

        if(this.props.userAlreadyExistsOtherPortal){
            this.validator.enableDisableRules(this.toggleFields,true);
            this.validator.enableDisableRules(this.toggleSignInFields,true);
            if(this.props.allowEmailEdit){
                this.validator.enableDisableRules(this.getEmailPasswordFields,false);
            }else {
                this.validator.enableDisableRules(this.getPasswordFields,false);
            }
        }
        this.state = {
            msg:'',
            email: (app.userAuth?app.userAuth.email:(this.props.email || this.props.data && this.props.data.email || '')),
            phoneNo: this.props.data && this.props.data.phone || '',
            fullName:'',
            password: this.props.data && this.props.data.password || '',
            confirmPassword: this.props.data && this.props.data.password || '',
            // cpassword: '', 
            validation: this.validator.valid(),
            authenticated: app.userAuth ? (!!(app.userAuth.userId)): false,
            userAlreadyExistsOtherPortal: this.props.userAlreadyExistsOtherPortal || false,
            allowEmailEdit:this.props.allowEmailEdit || false,
            
            companyName:''
          } 
      
        this.submitted = false;
        this.emaiChangeTimer = null; 
       // app.events.subscribe({[USER_SIGNIN]:this.userSignIn,/* [USER_SIGN_OUT] : this.userSignOut */},this);
    }
    componentDidUpdate(previousProps) {
        if(this.signIn!=this.props.signIn){
            this.setSignIn(this.props.signIn);
        }else if(previousProps.forgotPassword != this.props.forgotPassword){
            this.setState({error:'', msg:'', email:''}); 
            // this.setState({error:'', msg:'',emailphone: (this.props.forgotPassword && !this.state.emailphone && this.state.email) ? this.state.email : ''}); 
            //if(this.props.forgotPassword) this.validator.enableDisableRules(this.toggleForgotpasswordFields,false);
        }
    }
    componentDidMount() {
        ///For local development
        if(app.autoSignIn)this.login();
    } 
    // setAsSignIn(){
    //     this.setSignIn(true);
    // }
    // setAsSignUp(){
    //     this.setSignIn(false);
    // }
    login(event){
        if (event && event!=undefined && event.constructor != Object) event.preventDefault();
        if(this.props.forgotPassword){
            this.sendForgotPswdLink();
            return;
        } 
        const validation = this.validator.validate(this.state);
        this.setState({ validation,error:'' });
        this.submitted = true;
        
        ////auto SignIn chk For local development
        if (app.autoSignIn || validation.isValid) {
            var data = {}
            if(this.signIn){
                // let isnum = /^\d+$/.test(this.state.emailphone);
                let useremail = !this.state.countryCode?this.state.emailphone:null; 
                let phoneNo = this.state.countryCode? (this.state.countryCode+this.state.emailphone) :null;
                data = { useremail:useremail, phoneNo:phoneNo, password:this.state.password, username:this.state.username } 
                // data = { useremail:this.state.email,password:this.state.password } 
            }else {
                data = {
                    companyName: this.state.companyName.trim(),
                    name: this.state.fullName.trim(),
                    password: this.state.password.trim(),
                    confirmPassword:this.state.password.trim(),
                    contactDetails: {useremail: this.state.email, phone: this.state.phoneNo.trim()},
                    preferredLanguage:app.pageParams.lang
                }
            }
            app.events.trigger(SHOW_LOADER, { status: true});
                //login 
            var apiToCall = "userSignup";
            if(this.signIn){
                apiToCall = "userSignin";
                if(this.state.userAlreadyExistsOtherPortal){
                    apiToCall = "verifyAndSignup";
                }
            }else if(this.state.userAlreadyExistsOtherPortal){
                apiToCall = "verifyAndSignup";
            }
            let dataSources = [dataService.postRequest(apiToCall,data)];
            if(app.autoSignIn) dataSources = [dataService.getRequest(apiToCall,data)];
            // (this.signIn?"userSignin":this.state.userAlreadyExistsOtherPortal ? "verifyAndSignup" : "userSignup")
            // dataService.postRequest(apiToCall,data).then(res=>{
            Promise.all(dataSources).then(resData=>{
                let res = resData[0]
                app.events.trigger(SHOW_LOADER, { status: false});
                //console.log("login respose:"+res);
                if(this.signIn && res["status"] && res["status"] == "success") {
                    
                    
                    if(this.signIn && !res["errorAction"]){
                        let userdata = res.userdata;
                        let userAuth = {...(res.appAuthTokenTO || {}), ...userdata};
                        // userAuth.authUserId = userdata.userId;        
                        ///TODO remove use of app.userAuth.userId across portal
                        // userAuth.userId = res.supplierId;
                                   
                        // userAuth.supplierId = res.supplierId;
                        // userAuth.econtactId = res.econtactId;
                        app.events.trigger(USER_SIGNIN,userAuth,'login');
                        this.props.nextStep({},userAuth,'login',this.signIn);
                    }else if(this.signIn && res["errorAction"] == "SHOW_ERROR"){
                        this.setState({error: res ? translate(res.message||res.errorCode):''});
                    }else if(this.signIn && res["errorAction"] == "GET_PASSWORD" && res["errorCode"] == "OTHER_PORTAL_USER_EXISTS_WITH_EMAIL"){
                        this.setState({'userAlreadyExistsOtherPortal': true, 'error': res['message']});
                        if(this.props.setUserExistsOtherPortal){
                            this.props.setUserExistsOtherPortal(true);
                        }
                    }else if(res["errorAction"] == "GET_EMAIL_PASSWORD"){
                        this.setState({'userAlreadyExistsOtherPortal': true, 'allowEmailEdit':true, 'error': res['message'], 'password': null, 'email': null});
                        if(this.props.setUserExistsOtherPortal){
                            this.props.setUserExistsOtherPortal(true);
                        }
                    }else if(res["status"] && res["status"] == "error"){
                        this.setState({error: res ? translate(res.message):''});
                    }else if(res.error){
                        //console.log('this.signIn => '+this.signIn+' '+res.error);
                        let [e1,e2] = res.message.split(':');
                        this.setState({ error:(e2||e1)});
                    }else{
                        data['contactDetails'] = {'useremail':this.state.email.trim()};
                        this.props.nextStep({created:true, msg:res["message"], name:this.state.email.trim(), 'contactDetails':{'useremail':this.state.email.trim()}},data,'signup',this.signIn);
                        //this.props.nextStep({created:true, msg:res["message"], name:this.state.email.trim()},data,'signup',this.signIn);
                    }
                }else if(!this.signIn && res["status"] && res["status"] == "success"){
                    if(res["errorAction"] == "GET_PASSWORD"){
                        this.setState({'userAlreadyExistsOtherPortal': true, 'error': res['message'], 'password': null});
                        if(this.props.setUserExistsOtherPortal){
                            this.props.setUserExistsOtherPortal(true);
                        }
                    }else if (res["errorAction"] == "SHOW_ERROR"){
                        this.setState({error: res ? translate(res.message):''});
                    }else if(res["errorAction"] == "GET_EMAIL_PASSWORD"){
                        this.setState({'userAlreadyExistsOtherPortal': true, 'allowEmailEdit':true, 'error': res['message'], 'password': null, 'email': null});
                        if(this.props.setUserExistsOtherPortal){
                            this.props.setUserExistsOtherPortal(true);
                        }
                    }
                    else{
                        //this.props.nextStep({created:true, msg:res["message"], name:this.state.fullName.trim()},data,'login',this.signIn);
                        this.props.nextStep({created:true, msg:res["message"], name:res['userdata']['name'].trim()},data,'login',this.signIn);
                    }
                }else if(res["status"] && res["status"] == "error"){
                    this.setState({error: res ? translate(res.message):''});
                }else if(res.error){
                    //console.log('this.signIn => '+this.signIn+' '+res.error);
                    let [e1,e2] = res.message.split(':');
                    this.setState({ error:(e2||e1)});
                }
            })
            .catch((error) => {
                app.events.trigger(SHOW_LOADER, { status: false});
				this.setState({error: error ?error.message:'Error!'});
				// this.setState({error: error ?error.message:'Error!'});
			}); 
        } 
       
    } 
    
    checkPasswordCmp(password){
        let m = 0;
        if(password.match(".*[a-z]+.*"))
        {
            m++;
        }
        // if(password.match(".*[A-Z]+.*"))
        // {
        //     m++;
        // }
        if(password.match(".*[0-9]+.*"))
        {
            m++;
        }
        /*if(password.match(/[!@#$%^&*(),.?":{}|<>]/g))
        {
            m++;
        }*/
        return this.signIn || m > 1;
    } 
    passwordMatch(confirmation, state){
        return (state.password === confirmation);
    }
    // companyNameValidator(value) {
    //     // any alpha numeric with spaces
    //     return isAlphanumeric(value.replace(/\s+/g, ''), 'en-US');
    // }
    handleInputChange(event){
        if (event.constructor != Object) event.preventDefault();
        let field = this.aliasFields[event.target.name] || event.target.name;
        let countryCode= this.state.countryCode || null;
        if(event.target.inputtype == 'emailphone') countryCode = event.target.countryCode
        // if(event.target.inputtype == 'emailphone' || event.target.inputtype == 'phone') countryCode = event.target.countryCode
        this.setState({
          [field]: event.target.value, countryCode:countryCode
        });
    }
    setEmailCheckTimer(){
        this.ct++;
        clearTimeout(this.emaiChangeTimer);
        this.emaiChangeTimer = setTimeout(this.checkUserExist, WAIT_INTERVAL);
    }
    handleEmailKeyDown(e) {
        if (e.keyCode === ENTER_KEY) {
            this.checkUserExist();
        }
    }
    handleKeyPress(e) {
        if ((e.keyCode || e.which) === ENTER_KEY) { 
            this.login();
        }
    }
    setSignIn(signin){
        this.signIn = !!signin;
        this.submitted = false;
        this.validator.enableDisableRules(this.toggleFields,this.signIn);
        // if(this.signIn && this.props.forgotPassword) {
        //    this.validator.enableDisableRules(this.toggleForgotpasswordFields,false); 
        // } 
        this.validator.enableDisableRules(this.toggleSignInFields,!this.signIn);
        this.setState({validation: this.validator.valid()});
        this.setState({error:''});               
    }
    sendForgotPswdLink(){
        const validation = this.validator.validate(this.state); 
        this.setState({ validation,error:'' });
        this.submitted = true;

        //if (!validation.email.isInvalid) {
        if (!validation.emailphone.isInvalid) { 
            this.setState({error:''});
            //let emailphone = this.state.countryCode?(this.state.countryCode+this.state.emailphone):this.state.emailphone;
            let useremail = !this.state.countryCode?this.state.emailphone:null; 
            let phoneNo = this.state.countryCode? (this.state.countryCode+this.state.emailphone) :null;
            let data = { useremail:useremail, phoneNo:phoneNo, userType:'SELLER'}

        //    dataService.getRequest('forgotPassword',{email:this.state.email}).then(res=>{
             dataService.postRequest('forgotPassword', data).then(res=>{
                if(res && res.status.toLowerCase() == STATUS.SUCCESS.toLowerCase()){
                    this.props.nextStep({msg: translate('account.reset_mail_msg').replace('{0}', res.useremail) },null,'resetpassword',this.signIn);
                    //this.setState({postAction:true,msg: translate('account.reset_mail_msg')});
                }
                else if(res && res.error){
                    this.setState({error:(res.error && res.errorCode)?translate(res.errorCode):'Error!'});
                    //this.setState({postAction:true, msg:"",error: (res.error && res.errorCode)?translate(res.errorCode):'Error!'});
			    }
            }).catch((error) => {
                //this.setState({postAction:true, msg:"",error: (error && error.errorCode)?translate(error.errorCode):'Error!'});
                this.setState({error:(error && error.errorCode)?translate(error.errorCode):'Error!'});
			})
        }

        // if(validation.email.isInvalid){
        //    this.setState({error:translate('regn.email_for_reset_pwd')})
        // }
        // else{
        //     this.setState({error:''});
        //     this.props.nextStep({email:this.state.email},null,'resetpassword',this.signIn);                        
        // }
    }
    checkUserExist(){
        let ct = this.ct;
        this.processing = true;
        this.state.email && dataService.getRequest("userExist",{email:this.state.email}).then(res=>{
            //console.log(ct+'------------'+this.ct);
            this.processing = false;
            this.userId = res.userId;
            if(ct == this.ct){ 
            }                     
        });
    }
    render(){
        let validation = this.submitted ?this.validator.validate(this.state) : this.state.validation; 
        return( <React.Fragment>
            {/* {this.props.header && <div className="form-group"><label className="main-label">{this.signIn ? translate('regn_form_title2') : translate('regn_form_title1')}</label></div>} */}
                    
            {/* <form className={this.props.cls || 'form-row'} id={this.props.id || 'login-logout-form'}> */}
            {/* <form id={this.props.id || 'login-logout-form'} className={this.state.error?"is-invalid ":''}> */}
            <form id={this.props.id || 'login-logout-form'} >
                 
                    <FormMsg error={this.state.error}/>
                    <FormMsg msg={this.state.msg} type="success"/>
                    {!this.signIn && !this.state.authenticated && !this.state.userAlreadyExistsOtherPortal && 
                    <FormField
                        label='regn.companyName'
                        name="companyName" 
                        nameAlias = {this.fieldPrefix+"companyName"}
                        onChange={this.handleInputChange} 
                        onKeyPress={this.handleKeyPress}
                        value={this.state.companyName} 
                        placeholder='regn.enter_companyName'
                        validator={validation} 
                        required
                    />
                    }
                    {!this.signIn && !this.state.authenticated && !this.state.userAlreadyExistsOtherPortal && 
                    <FormField
                        label='regn.name'
                        name="fullName" 
                        nameAlias = {this.fieldPrefix+"fullName"}
                        onChange={this.handleInputChange} 
                        onKeyPress={this.handleKeyPress}
                        value={this.state.fullName} 
                        placeholder='regn.enter_name'
                        validator={validation} 
                        required
                    />
                    }   
                    {!this.signIn && !this.state.authenticated && !this.state.userAlreadyExistsOtherPortal && 
                    <FormField
                        label='regn.phone_number'
                        name="phoneNo" 
                        type="phone"
                        nameAlias = {this.fieldPrefix+"phoneNo"}
                        onChange={this.handleInputChange} 
                        onKeyPress={this.handleKeyPress}
                        value={this.state.phoneNo} 
                        placeholder='regn.enter_phone_number'
                        validator={validation} 
                        required
                        className="form-group countrycode"
                    />
                    }
                    {/* {((this.signIn && this.props.forgotPassword) || (!this.signIn && !this.state.authenticated && (!this.state.userAlreadyExistsOtherPortal || this.state.allowEmailEdit))) && */}
                    {!this.signIn && !this.state.authenticated && (!this.state.userAlreadyExistsOtherPortal || this.state.allowEmailEdit) &&
                    <FormField
                        label='regn.email'                        
                        name="email" 
                        nameAlias = {this.fieldPrefix+"email"}
                        onChange={this.handleInputChange} 
                        onKeyPress={this.handleKeyPress}
                        value={this.state.email} 
                        disabled={this.state.authenticated}
                        placeholder='regn.enter_email'
                        validator={validation} 
                        required
                        readOnly={(!this.signIn && this.state.userAlreadyExistsOtherPortal && !this.state.allowEmailEdit) || (this.signIn && this.state.userAlreadyExistsOtherPortal)}
                    /> }  

                    {/* 2372 */}
                    {this.signIn && (this.state.userAlreadyExistsOtherPortal || this.state.allowEmailEdit) &&
                    <FormField
                        label='regn.email'                        
                        name="email" 
                        nameAlias = {this.fieldPrefix+"email"}
                        onChange={this.handleInputChange} 
                        onKeyPress={this.handleKeyPress}
                        value={this.state.email} 
                        disabled={this.state.authenticated}
                        placeholder='regn.enter_email'
                        validator={validation} 
                        required                        
                    /> }
                    
                    {/* {(this.signIn && !this.props.forgotPassword) && */}
                    {( this.props.forgotPassword) && (!this.state.userAlreadyExistsOtherPortal && !this.state.allowEmailEdit) &&
                    <FormField
                        label='signin.unamelbl'
                        name="emailphone" 
                        type="emailphone" 
                        nameAlias = {this.fieldPrefix+"emailphone"}
                        onChange={this.handleInputChange} 
                        onKeyPress={this.handleKeyPress}
                        value={this.state.emailphone} 
                        disabled={this.state.authenticated}
                        placeholder='regn.enter_email_or_phone'
                        validator={validation} 
                        required
                        className="form-group countrycode"
                        readOnly={(!this.signIn && this.state.userAlreadyExistsOtherPortal && !this.state.allowEmailEdit) || (this.signIn && this.state.userAlreadyExistsOtherPortal)}
                    />
                    }
                    {(this.signIn && !this.props.forgotPassword ) && (!this.state.userAlreadyExistsOtherPortal && !this.state.allowEmailEdit) &&
                    <FormField
                        label='signin.username'
                        name="username"  
                        nameAlias = {this.fieldPrefix+"username"}
                        onChange={this.handleInputChange} 
                        onKeyPress={this.handleKeyPress}
                        value={this.state.username} 
                        disabled={this.state.authenticated}
                        placeholder='regn.enter_username'
                        validator={validation} 
                        required
                        className="form-group countrycode"
                        readOnly={(!this.signIn && this.state.userAlreadyExistsOtherPortal && !this.state.allowEmailEdit) || (this.signIn && this.state.userAlreadyExistsOtherPortal)}
                    />
                    }
                    {(this.signIn && !this.props.forgotPassword && !this.state.userAlreadyExistsOtherPortal || (!this.signIn && !this.state.allowEmailEdit)) &&
                    <FormField
                        label='regn.password'
                        name="password" 
                        type="password"
                        nameAlias = {this.fieldPrefix+"password"}
                        onChange={this.handleInputChange} 
                        onKeyPress={this.handleKeyPress}
                        value={this.state.password} 
                        disabled={this.state.authenticated}
                        placeholder='regn.enter_password'
                        validator={validation} 
                        validatorToolTip= {!this.signIn}
                        requireNumbers={1}
                        requireWords={1}
                        //requireCapitals={1}
                        minCharacters= {8}
                        required
                        className="form-group view-pswd"
                    />
                    }
                    {/* 2372 */}                    
                    {(this.state.userAlreadyExistsOtherPortal && this.state.allowEmailEdit) &&
                    <FormField
                        label='regn.password'
                        name="password" 
                        type="password"
                        nameAlias = {this.fieldPrefix+"password"}
                        onChange={this.handleInputChange} 
                        onKeyPress={this.handleKeyPress}
                        value={this.state.password} 
                        disabled={this.state.authenticated}
                        placeholder='regn.enter_password'
                        validator={validation} 
                        validatorToolTip= {!this.signIn}
                        requireNumbers={1}
                        requireWords={1}
                        //requireCapitals={1}
                        minCharacters= {8}
                        required
                        className="form-group view-pswd"
                    />
                    }                    
                    {/* {!this.signIn && this.props.login && !this.state.authenticated &&                      
                        <FormField
                              label='regn.confirm_password'
                            name="cpassword" 
                            type="password"
                            nameAlias = {this.fieldPrefix+"cpassword"}
                            onChange={this.handleInputChange} 
                            onKeyPress={this.handleKeyPress}
                            value={this.state.cpassword} 
                            placeholder='regn.confirm_password'
                            validator={validation} 
                        />
                    } */}
                    {(this.signIn || this.state.userAlreadyExistsOtherPortal) && <React.Fragment> 
                        <div className="btn-signup">
                            {this.props.forgotPassword && <button type="button" className="btn btn-primary btn-lg btn-block" onClick={this.sendForgotPswdLink}>{translate('regn.request_reset_link')}</button>}
                            {!this.props.forgotPassword && !this.state.userAlreadyExistsOtherPortal && <button type="button" className="btn btn-primary btn-lg btn-block" onClick={this.login}>{translate('signin')}</button>}    
                            {!this.props.forgotPassword && this.state.userAlreadyExistsOtherPortal && <button type="button" className="btn btn-primary btn-lg btn-block" onClick={this.login}>{translate('regn_confirm_and_signin')}</button>}    
                        </div>
                        <div className="form-group d-flex justify-content-center align-items-center mt-4 mb-4">
                            {/* {!this.props.forgotPassword && !this.state.userAlreadyExistsOtherPortal && <a href="javascript:void(0);" className="float-right" onClick={this.props.forgotPwdClick}>{translate('regn.forgot_password')}</a>} */}
                            {/* {this.props.forgotPassword && <label className="mb-0">{translate('regn.forgot_password_desc')}</label>} */}
                            {/* <a href="javascript:void(0);" className="float-right" onClick={this.sendForgotPswdLink}>{translate('regn.forgot_password')}</a> */}
                        </div>
                        
                    </React.Fragment> }
                    {!this.signIn && !this.state.userAlreadyExistsOtherPortal && <React.Fragment> 
                        <div className="form-text text-center mb-4">{translate('regn.terms_and_conditions')}</div>
                        <div className="btn-signup"><button type="button" className="btn btn-primary btn-lg btn-block" onClick={this.login}>{translate('regn.create_account')}</button></div>
                        
                    </React.Fragment>}
                 
            </form>    
            </React.Fragment>
        );
    }
}

export default Login;
